module.exports = __webpack_public_path__ + "static/media/luta.224b13cd.png";